"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchResubscribeEmailRequestStatus = exports.getFetchOptinFollowupEmailRequestStatus = exports.getFetchOptinEmailRequestStatus = exports.getResubscribeSubscriptionEmail = exports.getOptinSubscriptionEmail = exports.getOptinFollowupSubscriptionEmail = exports.getPortalDragAndDropStatusFetched = exports.getPortalDragAndDropAvailable = void 0;

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _SubscriptionEmailTypes = require("./SubscriptionEmailTypes");

var getSubscriptionEmails = function getSubscriptionEmails(state) {
  return state.modules.marketing.email.entities.subscriptionEmails;
};

var getPortalDragAndDropStatus = function getPortalDragAndDropStatus(state) {
  return state.modules.marketing.email.entities.portalDragAndDropAvailable;
};

var getPortalDragAndDropAvailable = (0, _reselect.createSelector)(getPortalDragAndDropStatus, function (status) {
  return status.getData();
});
exports.getPortalDragAndDropAvailable = getPortalDragAndDropAvailable;
var getPortalDragAndDropStatusFetched = (0, _reselect.createSelector)(getPortalDragAndDropStatus, function (status) {
  return status.hasEverLoaded();
});
exports.getPortalDragAndDropStatusFetched = getPortalDragAndDropStatusFetched;
var getOptinFollowupSubscriptionEmail = (0, _reselect.createSelector)([getSubscriptionEmails], function (subscriptionEmails) {
  return subscriptionEmails.get(_SubscriptionEmailTypes.OPTIN_FOLLOWUP_EMAIL);
});
exports.getOptinFollowupSubscriptionEmail = getOptinFollowupSubscriptionEmail;
var getOptinSubscriptionEmail = (0, _reselect.createSelector)([getSubscriptionEmails], function (subscriptionEmails) {
  return subscriptionEmails.get(_SubscriptionEmailTypes.OPTIN_EMAIL);
});
exports.getOptinSubscriptionEmail = getOptinSubscriptionEmail;
var getResubscribeSubscriptionEmail = (0, _reselect.createSelector)([getSubscriptionEmails], function (subscriptionEmails) {
  return subscriptionEmails.get(_SubscriptionEmailTypes.RESUBSCRIBE_EMAIL);
});
exports.getResubscribeSubscriptionEmail = getResubscribeSubscriptionEmail;
var getFetchOptinEmailRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionEmailsActionTypes.FETCH_OPTIN_EMAIL);
exports.getFetchOptinEmailRequestStatus = getFetchOptinEmailRequestStatus;
var getFetchOptinFollowupEmailRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionEmailsActionTypes.FETCH_OPTIN_FOLLOWUP_EMAIL);
exports.getFetchOptinFollowupEmailRequestStatus = getFetchOptinFollowupEmailRequestStatus;
var getFetchResubscribeEmailRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionEmailsActionTypes.FETCH_RESUBSCRIBE_EMAIL);
exports.getFetchResubscribeEmailRequestStatus = getFetchResubscribeEmailRequestStatus;